import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'myre-nav-logo',
  templateUrl: './navbar-logo.component.html',
  styleUrls: ['./navbar-logo.component.scss'],
  imports: [RouterLink],
})
export class NavbarLogoComponent {
  @Input()
  public redirectUrl: any[] | string | null | undefined;

  @Input()
  public logoUrl: string;
}
